import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = async (context) => ({
  redirect: {
    destination: `/admin/meetings/quick-call/${context.params?.['quick-call-id']}/edit`,
    permanent: false,
  },
});

export default function AdminQuickCallEditRedirect() {
  return null;
}
